<template>
  <div
    style="width: fit-content"
    :style="{
      backgroundColor: state.model?.BgColor,
      color: state.model?.Color,
      fontSize: props.size + 'px',
    }"
    :title="state.model?.Text"
  >
    {{ state.model?.Text || "-" }}
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import constant from "@/utils/constant";

export default {
  props: {
    arrName: String,
    value: {
      type: Object,
    },
    size: {
      type: Number,
      default: 14,
    },
  },
  setup(props) {
    const state = reactive({
      model: {},
      rlzData: [],
      yrlData: [],
    });

    onMounted(() => {
      state.model = constant[props.arrName].find((w) => w.Key == props.value);
    });

    return { props, state };
  },
};
</script>
<style lang="less" scoped></style>
